module.exports = __webpack_public_path__ + "static/media/align-text-center.edc46ce7.svg";